import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  CircularProgress,
  Pagination,
} from "@mui/material";
import UserCard from "./userCard";
import { Supervisor, SupervisorListProps } from "./types";

const SupervisorList: React.FC<SupervisorListProps> = ({
  data,
  loading,
  onSupervisorClick,
  searchQuery = "",
  selectedSupervisorId,
}) => {
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [renderedSupervisorId, setRenderedSupervisorId] = useState<string>("");
  const pageSize = 10;

  // Whenever supervisor data changes, reset pagination
  useEffect(() => {
    setTotalPages(Math.ceil(data.length / pageSize));
    setPage(1);
  }, [searchQuery, data]);

  // Decide which supervisors to render on screen
  // const supervisorsToRender =
  // renderedSupervisorId && renderedSupervisorId !== ""
  //   ? data.filter((s) => s.id === renderedSupervisorId)
  //   : data.slice((page - 1) * pageSize, page * pageSize);

  const supervisorsToRender = useMemo(() => {
    const term = searchQuery.trim().toLowerCase();
    if (!term) return data;
    return data.filter(
      (rep) =>
        rep.name.toLowerCase().includes(term) ||
        rep.mobile.toLowerCase().includes(term) ||
        rep.id.toLowerCase().includes(term) ||
        rep.salesRepsCount.toString().toLowerCase().includes(term)
    );
  }, [data, searchQuery]);

  // Handle dropdown change
  const handleDropdownChange = (value: string) => {
    if (value === "all") {
      setRenderedSupervisorId("");
      // onSupervisorClick?.(""); // reset selection
    } else {
      setRenderedSupervisorId(value);
      onSupervisorClick?.(value); // both are set
    }
  };

  // When "View SalesReps" clicked
  const handleViewSalesReps = (supId: string) => {
    onSupervisorClick?.(supId); // only selection changes
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Dropdown Header */}
      {/* <Box sx={{ px: 1.5, py: 2, flexShrink: 0 }}>
        <Typography sx={{ color: "#7c7c7c", fontSize: 14, mb: "3px" }}>
          Select Supervisor<span style={{ color: "red" }}>*</span>
        </Typography> */}

      {/* <Select
          fullWidth
          value={renderedSupervisorId || "all"}
          onChange={(e) => handleDropdownChange(e.target.value)}
          sx={{
            bgcolor: "#f9faf9",
            border: "0.5px solid #e9e9e9",
            borderRadius: 2,
            height: 44,
            ".MuiSelect-select": { padding: "8px 10px" },
            "& fieldset": { border: "none" },
          }}
        >
          <MenuItem value="all" sx={{ fontSize: 16, color: "#6e6f6e" }}>
            All
          </MenuItem>
          {data.map((sup) => (
            <MenuItem
              key={sup.id}
              value={sup.id}
              sx={{ fontSize: 16, color: "#6e6f6e" }}
            >
              {sup.name}
            </MenuItem>
          ))}
        </Select> */}
      {/* </Box> */}

      {/* Scrollable List */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          px: 1.5,
          py: 1,
          bgcolor: "white",
        }}
      >
        {loading ? (
          <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress
              size={24}
              sx={{ display: "block", mx: "auto", my: 2 }}
            />
          </Box>
        ) : (
          <>
            {/* <Typography
              sx={{
                color: "#00a392",
                fontSize: 14,
                mb: "3px",
                fontWeight: "bold",
              }}
            >
              {renderedSupervisorId && renderedSupervisorId !== ""
                ? `1 Supervisor`
                : `${data.length} Supervisors`}
            </Typography> */}

            {supervisorsToRender.length > 0 ? (supervisorsToRender.map((sup) => (
              <Box
                key={sup.id}
                sx={{
                  border:
                    sup.id === selectedSupervisorId
                      ? "2px solid #00a392"
                      : "none",
                  borderRadius: 2,
                  mb: 1.5,
                  transition: "border-color 0.2s ease-in-out",
                }}
              >
                <UserCard
                  name={sup.name}
                  mobile={sup.mobile || ""}
                  id={sup.id}
                  showCheckbox={false}
                  bottomText={`View SalesReps`}
                  // bottomText={`View ${sup.salesRepsCount ?? 0} SalesReps`}
                  onBottomClick={() => handleViewSalesReps(sup.id)}
                />
              </Box>
            ))) : (
                  <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography sx={{ textAlign: "center", color: "#9e9e9e" }}>
                      No Supervisors found
                    </Typography>
                  </Box>
            )}
          </>
        )}
      </Box>

      {/* Pagination only when showing all supervisors */}
      {totalPages > 1 && (!renderedSupervisorId || renderedSupervisorId === "") && (
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            zIndex: 2,
            borderTop: "1px solid #eee",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
            bgcolor: "white",
            gap: 1,
            py: 1
          }}
        // sx={{
        //   borderTop: "1px solid #eee",
        //   py: 1,
        //   display: "flex",
        //   justifyContent: "center",
        //   flexShrink: 0,
        //   bgcolor: "white",
        // }}
        >
          <Pagination
            count={totalPages}
            page={page}
            onChange={(_, value) => setPage(value)}
            size="small"
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default SupervisorList;

